<template>
  <div class="ip-location-card">
    <div class="ip-location-card-header pb-5 gap-5 d-flex align-items-center justify-space-between">
      <div class="w-100">
        <div class="d-flex align-items-center gap-5">
          <span
            data-testid="ip-location-card-title"
            class="strong text-default-size"
          >IP address and location</span>
          <span
            data-testid="ip-location-card-badge"
            class="badge badge-primary-lighter is-regular"
          >beta</span>
        </div>
        <span class="small text-lighter d-block">View approximate location based on IP at sign-in</span>
      </div>
      <AppButton
        type="outline"
        size="sm"
        class="ip-location-card-toggle-btn"
        @click="toggleLocation"
      >
        {{ hidden ? 'Show location' : 'Hide location' }}
      </AppButton>
    </div>

    <div
      v-if="!hidden"
      data-testid="ip-location-card-fields"
    >
      <div class="row">
        <div class="col-md-6 col-sm-12">
          <div class="form-group mb-16">
            <label class="control-label">IP ADDRESS</label>
            <AppInput
              :value="ipLocation.ip || '—'"
              readonly
              placeholder="No IP address"
            />
          </div>
        </div>
        <div class="col-md-6 col-sm-12">
          <div class="form-group mb-16">
            <label class="control-label">COUNTRY</label>
            <AppInput
              :value="ipLocation.country || '—'"
              readonly
              placeholder="No country"
            />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6 col-sm-12">
          <div class="form-group">
            <label class="control-label">CITY</label>
            <AppInput
              :value="ipLocation.city || '—'"
              readonly
              placeholder="No city"
            />
          </div>
        </div>
        <div class="col-md-6 col-sm-12">
          <div class="form-group">
            <label class="control-label label-with-tooltip">
              DATE
              <i
                v-tooltip
                class="hi hi-info-filled a-tooltip"
                data-placement="right"
                data-original-title="Date of last interaction with the app from this IP"
              />
            </label>
            <AppInput
              :value="formattedDate || '—'"
              readonly
              placeholder="No date"
            />
          </div>
        </div>
      </div>
    </div>

    <div
      v-if="!hidden"
      data-testid="ip-location-card-footer"
      class="mt-10"
    >
      <p
        data-testid="ip-location-card-disclaimer"
        class="small text-lighter mb-10"
      >
        This is an approximate region based on IP address at sign in. If the member is using a VPN, this region may not be accurate
      </p>
      <a
        data-testid="ip-location-card-feedback-link"
        class="ip-location-card__feedback-link strong small"
        href="#"
        @click.prevent="showFeedbackDialog = true"
      >
        Share feedback on this feature
      </a>
    </div>

    <IpLocationFeedbackDialog
      :show="showFeedbackDialog"
      :membership-id="membershipId"
      :organization-id="organizationId"
      :user-name="userName"
      @close="showFeedbackDialog = false"
    />
  </div>
</template>

<script>
import dayjs from 'dayjs';
import IpLocationFeedbackDialog from './IpLocationFeedbackDialog.vue';
import AppButton from '~/components/AppButton.vue';
import AppInput from '~/components/AppInput.vue';

export default {
  name: 'MemberIpLocationCard',
  components: {
    IpLocationFeedbackDialog,
    AppButton,
    AppInput,
  },
  props: {
    ipLocation: {
      type: Object,
      required: true,
    },
    membershipId: {
      type: Number,
      required: true,
    },
    organizationId: {
      type: Number,
      required: true,
    },
    userName: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      hidden: true,
      showFeedbackDialog: false,
    };
  },
  computed: {
    formattedDate() {
      if (!this.ipLocation.date) {
        return null;
      }

      return dayjs(this.ipLocation.date).format('ddd, MMM D, YYYY');
    },
  },
  methods: {
    toggleLocation() {
      this.hidden = !this.hidden;
      window.analytics?.track('IP Location Toggled', { feature: 'ip_geoloc' });
    },
  },
};
</script>
